import React from 'react';
// import {useLocation} from 'react-router-dom';
import SuluxLogo from '../Logo';
import Navbar from './navbar';
import HeaderSearch from './search';
import NavOtherLink from './navOtherLinks';
import SuluxSocial from '../Social';

const Header  = (props) => {
    //const {pathname}= useLocation();

    return(
        <div className={`c-header  py-20 border-b-1 border-gray-400 lg:border-0 lg:px-32 xl:px-144 absolute top-0 left-0 right-0 z-50 ${props.className}`}>
            <div className="px-16 lg:px-0">
                <div className="flex items-center justify-between -mx-16">
                    <div className="px-16 lg:flex-1 lg:flex lg:justify-start">
                        <Navbar/>
                    </div>
                    <div className="px-16 lg:flex-1 lg:flex lg:justify-center lg:text-center">
                        <SuluxLogo/>
                    </div>
                    <div className="px-16 lg:flex-1 lg:flex lg:items-center lg:justify-end">
                        <NavOtherLink/>
                        <div className="lg:ml-16">
                            <HeaderSearch/>
                        </div>
                        <div className="hidden lg:block lg:ml-16">
                            <SuluxSocial/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Header;